import { render, staticRenderFns } from "./remotePlay.vue?vue&type=template&id=03e3972b"
import script from "./remotePlay.vue?vue&type=script&lang=js"
export * from "./remotePlay.vue?vue&type=script&lang=js"
import style0 from "./remotePlay.vue?vue&type=style&index=0&id=03e3972b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports